<template>
    <div>
        <b-modal size="xl" centered title="Preview Surat" :ok-only="true" :lazy="true"
            v-model="ShowPreviewLetter">
            <template v-if="PDFBlob">
                <iframe :src="PDFBlob" frameborder="0" width="100%" height="100%"></iframe>
            </template>
        </b-modal>

        <b-row>
            <template v-if="ListOfLetters.length > 0">
                <b-col cols="12" class="mb-1" v-for="(Letter, IndexLetter) in ListOfLetters" :key="IndexLetter">
                    <div class="mb-1 d-flex align-items-center justify-content-start">
                        <div class="mr-1">{{ Letter.NamaSurat }}</div>
                        <div class="d-flex align-items-center">
                            <button type="button" class="btn btn-link mr-1 m-0 p-0"
                                @click="DownloadLetter(Letter)">
                                <font-awesome-icon class="align-middle"
                                    style="color:#3b3e66;padding:5px;font-size:1.7em;" icon="download" />
                            </button>
                            <button type="button" class="btn btn-link ml-1 m-0 p-0"
                                @click="PreviewLetter(Letter.PDFBase64)">
                                <font-awesome-icon class="align-middle"
                                    style="color:#3b3e66;padding:5px;font-size:1.7em;" icon="eye" />
                            </button>
                        </div>
                    </div>
                </b-col>
            </template>
            <template v-else-if="propSuratRujukBpjs"></template>
            <template v-else>
                <b-col cols="12">
                    <span>-</span>
                </b-col>
            </template>
            <b-col cols="12" class="mb-1" v-if="propSuratRujukBpjs">
                <div class="mb-1 d-flex align-items-center justify-content-start">
                    <div class="mr-1">Surat Rujukan BPJS</div>
                    <div class="d-flex align-items-center">
                        <button type="button" class="btn btn-link mr-1 m-0 p-0"
                            @click="DownloadSuratRujukBpjs()">
                            <font-awesome-icon class="align-middle"
                                style="color:#3b3e66;padding:5px;font-size:1.7em;" icon="download" />
                        </button>
                        <button type="button" class="btn btn-link ml-1 m-0 p-0"
                            @click="PreviewSuratRujukBpjs()">
                            <font-awesome-icon class="align-middle"
                                style="color:#3b3e66;padding:5px;font-size:1.7em;" icon="eye" />
                        </button>
                    </div>
                </div>
            </b-col>
        </b-row>
        </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LetterMap } from './Helpers/LetterMap'
import { ParseJenisKelaminSurat } from './Helpers/ParseJenisKelaminSurat';

export default {
    name: 'SuratPenunjangRiwayatRekamMedis',
    props: ['TransKlinikID', 'propSuratRujukBpjs'],
    data() {
        return {
            ListOfLetters: [],
            ShowPreviewLetter: false,
            PDFBlob: null,
            SuratRujukBpjsBlob: null
        }
    },
    watch: {
        TransKlinikID: {
            handler: async function (val) {
                if (val) {
                    this.$nextTick(async () => {
                        await this.GetListOfLetter()
                    })
                }
            },
            immediate: true
        },
        propSuratRujukBpjs: {
            handler: async function (val) {
                if (val) {
                    this.$nextTick(async () => {
                        await this.GetSuratRujukBPJS()
                    })
                }
            },
            immediate: true
        },
        ShowPreviewLetter: {
            handler: function (val) {
                if (!val) {
                    this.$nextTick(() => {
                        URL.revokeObjectURL(this.PDFBlob);

                        this.PDFBlob = null
                    })

                }
            }
        }
    },
    computed: {
        ...mapGetters('SuratPenunjangStore', ['API_URL']),
        DaftarSuratEndpoint() {
            return `${this.API_URL}/daftar-surat`
        }
    },
    beforeDestroy() {
        this.$nextTick(() => {
            this.ResetSuratPenunjangStore();
        })
    },
    methods: {
        ...mapActions('SuratPenunjangStore', ['ResetSuratPenunjangStore']),
        async GetListOfLetter() {
            const { data } = await this.$axios.get(`${this.DaftarSuratEndpoint}/${this.TransKlinikID}`);

            if (data.length > 0) {
                this.ListOfLetters = data.map(item => {
                    return {
                        SuratID: item.id,
                        NamaPasien: item.nama_pasien.trim(),
                        UmurPasien: item.umur_pasien,
                        JenisKelamin: ParseJenisKelaminSurat(item.jenis_kelamin_pasien),
                        NamaSurat: LetterMap(item.table_name),
                        PDFBase64: item.pdf_base64
                    }
                })
            } else {
                this.ListOfLetters = []
            }

            return true
        },
        async GetSuratRujukBPJS() {
            try {
                const res = await this.$axios.post(
                    `bpjs/surat_rujuk_blob`, {link: this.propSuratRujukBpjs.link, name: this.propSuratRujukBpjs.name}, {responseType: 'blob'}
                );
                const blob = new Blob(
                    [res.data], 
                    { type: 'application/pdf' }
                );

                this.SuratRujukBpjsBlob = blob;
            } catch (error) {
                // console.log(error);
            }
        },
        async PreviewSuratRujukBpjs() {
            const PDFBlob = URL.createObjectURL(this.SuratRujukBpjsBlob);
            if (this.isMobile() || this.isMobileTab()) {
                const link = document.createElement('a');
                link.href = PDFBlob;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setTimeout(() => URL.revokeObjectURL(PDFBlob), 1000);
                return;
            }
            this.PDFBlob = PDFBlob

            this.ShowPreviewLetter = !this.ShowPreviewLetter
        },
        async DownloadSuratRujukBpjs() {
            this.$nextTick(async () => {
                const PDFBlob = URL.createObjectURL(this.SuratRujukBpjsBlob);

                const link = document.createElement('a');
                link.href = PDFBlob;
                link.download = this.propSuratRujukBpjs.name;
                link.click();
            })
        },
        async PreviewLetter(PDFBase64) {
            const TmpPDFBlob = await fetch(PDFBase64).then(res => res.blob());

            const PDFBlob = URL.createObjectURL(TmpPDFBlob);
            if (this.isMobile() || this.isMobileTab()) {
                const link = document.createElement('a');
                link.href = PDFBlob;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setTimeout(() => URL.revokeObjectURL(PDFBlob), 1000);
                return;
            }
            this.PDFBlob = PDFBlob

            this.ShowPreviewLetter = !this.ShowPreviewLetter
        },
        async DownloadLetter(Letter) {
            let filename = '';
            if (Letter.NamaSurat) filename += `${Letter.NamaSurat.replace(/ /g, '_')}`;
            if (Letter.NamaPasien) {
                if (Letter.NamaSurat) filename += '_';
                filename += `${Letter.NamaPasien.replace(/ /g, '_')}`;
            }
            
            this.$nextTick(async () => {
                const TmpPDFBlob = await fetch(Letter.PDFBase64).then(res => res.blob());

                const PDFBlob = URL.createObjectURL(TmpPDFBlob);

                const link = document.createElement('a');
                link.href = PDFBlob;
                link.download = `${filename}.pdf`;
                link.click();
            })
        }
    }
}
</script>